import mapBig from '../resources/FEL.jpg'
import mapSmall from '../resources/FEL_small.jpg'

export default `
# Místo konání

Fakulta elektrotechnicka, Karlovo náměstí, budova E
Praha 2, Karlovo náměstí 13

GPS: 50.07667N, 14.41789E

[![Mapa](${mapSmall})](${mapBig})
`



// WEBPACK FOOTER //
// ./src/content/installfest/venue/text.js